import Vue from 'vue'
import Router from 'vue-router'
import Map from '@/components/Map'
import Projects from '@/components/Projects'
import Tags from '@/components/Tags'
import Reminder from '@/components/Reminder'
import Options from '@/components/Options'
import VueFire from 'vuefire'

Vue.use(VueFire)
Vue.use(Router)

export default new Router({
  mode: 'history',
  hashbang: false,
  linkActiveClass: 'active',
  transitionOnLoad: true,
  routes: [
    {
      path: '/',
      name: 'Map',
      component: Map,
      props: true
    },
    {
      path: '/projekte',
      name: 'Projects',
      component: Projects
    },
    {
      path: '/tags',
      name: 'Tags',
      component: Tags
    },
    {
      path: '/merkliste',
      name: 'Reminder',
      component: Reminder
    },
    {
      path: '/optionen',
      name: 'Options',
      component: Options
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js